import Header from "../../shared/header/header";
import Footer from "../../shared/footer/footer";
import AboutComponent from "../../shared/about/aboutComponent";

const AboutCommon = () => {
	return (
		<div>
			<Header />
			<AboutComponent />
			<Footer />
		</div>
	);
};

export default AboutCommon;
